<template>
  <div class="flow-progress" :class="`flow-progress--${color}`">
    <span class="flow-progress__value">{{ progress }}%</span>
    <progress class="flow-progress__bar" max="100" :value="progress" :style="{height: `${height}px`}"></progress>
  </div>
</template>

<script>
export default {
  name: 'flow-progress',
  props: {
    progress: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      default: 'green',
    },
    height: {
      type: Number,
      default: 16,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';

.flow-progress {
  position: relative;
  text-align: center;
  margin: 0 auto;
  width: 300px;
  @media (min-width: $breakpoint-sm) {
    width: 400px;
  }
  &__value {
    position: absolute;
    top: -20px;
    right: 0;
    font-weight: 600;
  }
  &__bar {
    appearance: none;
    width: inherit;
    &::-webkit-progress-bar {
      background: #e0e0e0;
      border-radius: 14px;
    }
    &::-webkit-progress-value {
      border-radius: 14px;
      transition: width 1s ease-in-out;
    }
  }
  &--green .flow-progress__bar {
    &::-webkit-progress-value {
      background: $half-baked-color;
    }
  }
}
</style>
